import React from "react";
import { InventoryTypeContent } from "../../content/inventoryType/inventoryTypeList";
import { Layout } from "../../layout/page";

export function InventoryType() {
  return (
    <Layout>
      <InventoryTypeContent />
    </Layout>
  );
}
